module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-range-fill-29bbdab9.svg";